module.exports = __webpack_public_path__ + "img/sony-75class-tv.9f82c4b3.jpg";